skrilla.directive('userWithSubmittedRosters', function () {
    return {
        templateUrl: 'directives/usersWithSubmittedRosters/usersWithSubmittedRosters.html',
        scope: {
            contest: "=",
            type: "="
        },
        controller: function ($scope, searchService, contestsService) {
            $scope.getLocalWinAmount = contestsService.getLocalWinAmount;
            searchService.get($scope.type + '/contests/daily/' + $scope.contest.contestId + '/submittedUsers').then(function(response){
                $scope.users = response.data.result;
            });
        }
    };
});
